import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const DynamicBreadcrumb = ({ items }) => {
  // Render breadcrumb items dynamically based on the 'items' prop
  const renderBreadcrumbItems = () => {
    return items?.map((item, index) => (
      <BreadcrumbItem key={index} active={index === items.length - 1}>
        <Link to={item.link}>{item.text} </Link>
      </BreadcrumbItem>
    ))
  }

  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-flex align-items-center">
          <div className="page-title-right">
            <ol className="breadcrumb m-0">{renderBreadcrumbItems()}</ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

DynamicBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string,
    })
  ).isRequired,
}

export default DynamicBreadcrumb
